












































































































































































































import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import CardCatatanKebidananInput from "./CardCatatanKebidananInput.vue";
import CardModalTtd from "@/components/modal/CardModalTtd.vue";
import CatatanKebidananStore from "@/store/modules/CatatanKebidananStore";
import CatatanKebidananSvc from "@/services/CatatanKebidanan";
import { userModule } from "@/store/modules/user";
import { appModule } from "@/store/modules/app";
import { SUBTIPE_LABELS } from "@/utils/abortusSubtipe";

@Component({
  components: {
    CardCatatanKebidananInput,
    CardModalTtd
  },
  inject: { isReadOnly: { default: () => () => false } }
})
export default class CatatanKebidananPage extends Vue {
  @Prop() register!: any;
  @Prop() rm!: any;
  @Prop({ default: false }) isActive!: boolean;

  isReadOnly!: () => boolean;
  get readOnly(): boolean {
    return this.isReadOnly();
  }

  showForm = false;
  editData: any = null;
  dialogDelete = false;
  deleteTarget: any = null;
  ttdDialog = false;
  ttdItem: any = null;
  ttdRole = "bidan";

  headers = [
    { text: "No", value: "no", sortable: false, width: "50px" },
    { text: "Tanggal", value: "tanggal", width: "100px" },
    { text: "Shift", value: "shift", width: "100px" },
    { text: "Fase", value: "fase", width: "180px" },
    { text: "Diagnosa", value: "diagnosa_kebidanan" },
    { text: "Tindakan", value: "tindakan_count", sortable: false, width: "90px" },
    { text: "Bidan", value: "bidan", width: "150px" },
    { text: "Aksi", value: "aksi", sortable: false, width: "100px" },
    { text: "", value: "data-table-expand" }
  ];

  mounted() {
    if (this.register) {
      this.loadData();
    }
  }

  @Watch("register")
  onRegisterChange() {
    this.loadData();
  }

  @Watch("isActive")
  onActiveChange(val: boolean) {
    if (val && this.register) {
      this.loadData();
    }
  }

  get loading() {
    return CatatanKebidananStore.loading;
  }

  get dataList() {
    return CatatanKebidananStore.dataList;
  }

  async loadData() {
    if (!this.register) return;
    const regNo = typeof this.register === "object" ? this.register.no : this.register;
    await CatatanKebidananStore.getByRegister(regNo);
  }

  formatDate(dateStr: string) {
    if (!dateStr) return "-";
    const d = new Date(dateStr);
    const dd = String(d.getDate()).padStart(2, "0");
    const mm = String(d.getMonth() + 1).padStart(2, "0");
    const yyyy = d.getFullYear();
    return `${dd}-${mm}-${yyyy}`;
  }

  shiftLabel(shift: string) {
    const labels: Record<string, string> = {
      pagi: "Pagi",
      siang: "Siang",
      malam: "Malam"
    };
    return labels[shift] || shift;
  }

  shiftColor(shift: string) {
    const colors: Record<string, string> = {
      pagi: "orange",
      siang: "blue",
      malam: "indigo"
    };
    return colors[shift] || "grey";
  }

  editItem(item: any) {
    if (this.readOnly) return;
    this.editData = { ...item };
    this.showForm = true;
  }

  alasanTidakBisaHapus(item: any): string {
    if (this.readOnly) return "Rekam medis sudah terkunci (read-only)";
    if (item.signed_bpja) return "Sudah diverifikasi BPJA, tidak dapat dihapus";
    const uid = userModule.user?.id;
    if (item.signed_bidan && (item.creator_user_id !== uid || item.bidan_user_id !== uid)) {
      return "Sudah ditandatangani, hanya dapat dihapus oleh pembuat yang menandatanganinya";
    }
    return "";
  }

  deleteItem(item: any) {
    if (this.alasanTidakBisaHapus(item)) return;
    this.deleteTarget = item;
    this.dialogDelete = true;
  }

  async confirmDelete() {
    if (this.readOnly) return;
    if (!this.deleteTarget) return;
    try {
      await CatatanKebidananSvc.destroy(this.deleteTarget.id);
      this.dialogDelete = false;
      this.deleteTarget = null;
      this.loadData();
    } catch (e) {
      // error handled by service
    }
  }

  subtipeLabel(key: string): string {
    return (SUBTIPE_LABELS as Record<string, string>)[key] || key;
  }

  onSaved() {
    this.showForm = false;
    this.editData = null;
    this.loadData();
  }

  onCancel() {
    this.showForm = false;
    this.editData = null;
  }

  canSignBidan(item: any): boolean {
    return !item.signed_bidan && item.bidan_user_id === userModule.user?.id;
  }

  canSignBpja(item: any): boolean {
    // BPJA (Bidan Penanggung Jawab Asuhan) — berbeda dari bidan pelaksana
    return !item.signed_bpja && item.bidan_user_id !== userModule.user?.id;
  }

  openTtd(item: any, role = "bidan") {
    this.ttdItem = item;
    this.ttdRole = role;
    this.ttdDialog = true;
  }

  async confirmTtd(password: string) {
    if (!this.ttdItem) return;
    const isBpja = this.ttdRole === "bpja";

    try {
      const resp = isBpja
        ? await CatatanKebidananSvc.signBpja(this.ttdItem.id, { password })
        : await CatatanKebidananSvc.signBidan(this.ttdItem.id, { password });
      if (resp.status == 1) {
        appModule.NoticeDelay(`Berhasil menandatangani (${isBpja ? "BPJA" : "Bidan"})`);
        this.ttdDialog = false;
        this.ttdItem = null;
        this.loadData();
      }
    } catch (e) {
      // error handled by service
    }
  }

  cetakPdf() {
    const regNo = typeof this.register === "object" ? this.register.no : this.register;
    CatatanKebidananSvc.printPdf(regNo);
  }
}
